import { Button, Cards, ContainerSpace } from "./styles";
import icon5 from '../../assets/Img/icon5.png';
import tuesday4 from '../../assets/Img/tuesday4.jpg';
import tuesday5 from '../../assets/Img/tuesday5.jpg';
import tuesday6 from '../../assets/Img/tuesday6.jpg';
import tuesday7 from '../../assets/Img/tuesday7.jpg';


export function Space() {
    return (
        <ContainerSpace>
            <h2>OUR SPACE</h2>
            <img src={icon5} alt="icon of two pyramids with the sun on top" />
            <h1>69, -34</h1>
            <p>
                Our building is a modern take on a tree–one of the world’s naturally-occurring fractals.
                Despite its size, Fractalia hosts a series of mini experiences and games, giving you a chance to win a rare NFT.
                You may also purchase our exclusive line of wearables from our Anima Plasma collection.
            </p>
            <Cards>
                <div className="inner-card">
                    <img src={tuesday4} alt="illustration of what Fractalia space looks like" />
                    <img src={tuesday5} alt="illustration of what Fractalia space looks like" />
                </div>
                <div className="inner-card">
                    <img src={tuesday6} alt="illustration of what Fractalia space looks like" />
                    <img src={tuesday7} alt="illustration of what Fractalia space looks like" />
                </div>
            </Cards>
            <Button>
                <a href="https://play.decentraland.org/?island=I5a5k&position=69%2C-34&realm=baldr" target="_blank" rel="noreferrer">VISIT FRACTALIA</a>
            </Button>
        </ContainerSpace>
    )
}